import type {NavSearchEnterOutcome} from '@Components/nav-search/nav-search.types';

export interface TemplateSearchContentProps {
  containsSearchInDropdown?: boolean;
  onSelectItem?: (outcome: NavSearchEnterOutcome) => void;
  isNavigating?: boolean;
}

/** Held in redux; append new values, never renumber. */
export enum SearchPillTypes {
  TEMPLATE = 1,
  MY_DESIGNS = 2,
  AI = 3,
  EVENTS = 4,
  SOCIAL_POSTS = 5,
  EMAILS = 6,
  AUDIENCE = 7,
  /** The Folders page's scope. Deliberately has no pill: the rail shows nothing selected while it is in play. */
  FOLDERS = 8,
}

export type SectionSearchPillType = SearchPillTypes.EVENTS | SearchPillTypes.SOCIAL_POSTS | SearchPillTypes.EMAILS | SearchPillTypes.AUDIENCE;

const SECTION_SEARCH_PILL_TYPES: SectionSearchPillType[] = [SearchPillTypes.EVENTS, SearchPillTypes.SOCIAL_POSTS, SearchPillTypes.EMAILS, SearchPillTypes.AUDIENCE];

export const isSectionSearchPillType = (pillType: SearchPillTypes): pillType is SectionSearchPillType => {
  return SECTION_SEARCH_PILL_TYPES.some((sectionPillType) => {
    return sectionPillType === pillType;
  });
};
